module.exports = __webpack_public_path__ + "assets/images/project/constituencies/west-coast-grc.jpg?v=36da9704";